<div [formGroup]="form()">
  @switch (field().controlType) {
    @case (FieldType.TEXTBOX) {
      <label
        class="fw-bold"
        [attr.for]="field().key"
        >{{ field().settings?.label }}
        @if (field().settings?.required) {
          <span class="text-primary ms-1">*</span>
        }
      </label>

      <input
        [formControlName]="field().key"
        class="form-control mt-2"
        [id]="field().key"
        type="text"
        [placeholder]="field().settings?.placeholder ?? '' | translate"
      />
    }

    @case (FieldType.CHECKBOX) {
      <div
        class="form-check custom-control custom-checkbox dynamic-form-field-checkbox"
      >
        <input
          class="form-check-input custom-control-input"
          type="checkbox"
          [id]="field().key"
          [formControlName]="field().key"
        />

        <label
          [attr.for]="field().key"
          class="mb-0 form-check-label custom-control-label"
          translate
          >{{ field().settings?.label }}</label
        >
      </div>
    }

    @case (FieldType.STAR_RATING) {
      <app-star-rating-field
        [field]="field()"
        [form]="form()"
      />
    }

    @case (FieldType.DROPDOWN) {
      <app-dropdown-field
        [field]="field()"
        [form]="form()"
      />
    }

    @case (FieldType.NUMBER) {
      <label
        class="fw-bold"
        [attr.for]="field().key"
        translate
        >{{ field().settings?.label }}</label
      >

      <input
        [formControlName]="field().key"
        class="form-control"
        [id]="field().key"
        type="number"
        [placeholder]="field().settings?.placeholder ?? ''"
      />
    }

    @case (FieldType.CHOICES_RATING) {
      <app-choices-rating-field
        [field]="field()"
        [form]="form()"
      />
    }

    @case (FieldType.DYNAMIC_CHOICES) {
      <app-dynamic-choices-field
        [field]="field()"
        [form]="form().get(field().key)"
      />
    }

    @case (FieldType.YES_NO_RATING) {
      <app-yes-no-rating-field
        [field]="field()"
        [form]="form()"
      />
    }

    @case (FieldType.TEXTAREA) {
      <label
        class="fw-bold"
        [attr.for]="field().key"
        translate
        >{{ field().settings?.label }}</label
      >

      <textarea
        [formControlName]="field().key"
        class="form-control mt-2"
        [id]="field().key"
        [placeholder]="field().settings?.placeholder ?? '' | translate"
        [rows]="3"
      ></textarea>
    }

    @case (FieldType.SECTION_SUMMARY) {
      <app-section-summary-field
        [field]="field()"
        [form]="form()"
        [inEditorMode]="inEditorMode()"
      />
    }

    @case (FieldType.RICH_TEXT_EDITOR) {
      <app-rich-text-editor-field
        [field]="field()"
        [form]="form()"
      />
    }

    @case (FieldType.FREE_TEXT) {
      <app-free-text-field
        [field]="field()"
        [form]="form()"
      />
    }
  }

  @if (errorMessageDisplayed) {
    <div
      class="alert alert-danger"
      translate
    >
      JuryForm.Validation.Required
    </div>
  }
</div>
